import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CareerList from '../components/CareerList';
import CareerApplicationList from '../components/CareerApplicationList';
import { careerService } from '../services/apiService';

const Careers = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('positions');

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Verify we have a valid token by making a simple request
        await careerService.getAllCareers();
        setLoading(false);
      } catch (err) {
        if (err.message.includes('401')) {
          navigate('/login');
        } else {
          setError(err.message || 'Failed to verify authentication');
          setLoading(false);
        }
      }
    };

    checkAuth();
  }, [navigate]);

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Career Management</h2>
      
      {/* Tabs */}
      <div className="flex gap-4 mb-6 border-b">
        <button
          onClick={() => setActiveTab('positions')}
          className={`px-4 py-2 font-medium transition-colors ${
            activeTab === 'positions'
              ? 'text-green-700 border-b-2 border-green-700'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Career Positions
        </button>
        <button
          onClick={() => setActiveTab('applications')}
          className={`px-4 py-2 font-medium transition-colors ${
            activeTab === 'applications'
              ? 'text-green-700 border-b-2 border-green-700'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Applications
        </button>
      </div>

      {/* Content */}
      {activeTab === 'positions' && <CareerList />}
      {activeTab === 'applications' && <CareerApplicationList />}
    </div>
  );
};

export default Careers;